import { Injectable } from "@angular/core";

@Injectable()
export class PagingVariables {
    quantity: number;
    pageIndex = 0;
    pageSize = 20;
}
